<template>
  <div class="sampleList">
    <div>
        <div style="width: 300px; float: left;">
            <el-input
                placeholder="견적번호, 거래처, 품목, 사업장, 견적인"
                prefix-icon="el-icon-search"
                v-model="search">
            </el-input>
        </div>
        <div style="float: right;">
            
        </div>
    </div>
    <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
            prop="no"
            label="No"
            width="80">
        </el-table-column>
        <el-table-column
            prop="number"
            label="견적번호"
            width="120">
            <template slot-scope="scope">
                <el-button type="text" size="small">{{scope.row.number}}</el-button>
            </template>
        </el-table-column>
        <el-table-column
            prop="customer_name"
            label="거래처">
        </el-table-column>
        <el-table-column
            prop="product_name"
            label="품목">
        </el-table-column>
        <el-table-column
            prop="customer_location"
            label="사업장"
            width="120">
        </el-table-column>
        <el-table-column
            prop="price"
            label="견적가"
            width="80">
        </el-table-column>
        <el-table-column
            prop="status"
            label="상태"
            width="60">
        </el-table-column>
        <el-table-column
            prop="estimation_charger"
            label="견적인"
            width="100">
        </el-table-column>      
        <el-table-column
            prop="estimation_date"
            label="견적일"
            width="100">
        </el-table-column>            
    </el-table>
  </div>
</template>

<script>
export default {  
  name: 'sampleList',
  data() {
    return {
        search: '',
        tableData: [
        {
            no: 10,
            number: '19A0101',
            customer_name: '청주 제일강화도어',
            product_name: '반자동기계외도어',
            customer_location: '남이면 양촌4길',
            price: '120,000',
            status: '상태',
            estimation_charger: '홍길동',
            estimation_date: '2019-11-06'
        }, {
            no: 9,
            number: '19A0101',
            customer_name: '청주 제일강화도어',
            product_name: '반자동기계외도어',
            customer_location: '남이면 양촌4길',
            price: '120,000',
            status: '상태',
            estimation_charger: '홍길동',
            estimation_date: '2019-11-06'
        }, {
            no: 8,
            number: '19A0101',
            customer_name: '청주 제일강화도어',
            product_name: '반자동기계외도어',
            customer_location: '남이면 양촌4길',
            price: '120,000',
            status: '상태',
            estimation_charger: '홍길동',
            estimation_date: '2019-11-06'
        }, {
            no: 7,
            number: '19A0101',
            customer_name: '청주 제일강화도어',
            product_name: '반자동기계외도어',
            customer_location: '남이면 양촌4길',
            price: '120,000',
            status: '상태',
            estimation_charger: '홍길동',
            estimation_date: '2019-11-06'
        }, {
            no: 6,
            number: '19A0101',
            customer_name: '청주 제일강화도어',
            product_name: '반자동기계외도어',
            customer_location: '남이면 양촌4길',
            price: '120,000',
            status: '상태',
            estimation_charger: '홍길동',
            estimation_date: '2019-11-06'
        }, {
            no: 5,
            number: '19A0101',
            customer_name: '청주 제일강화도어',
            product_name: '반자동기계외도어',
            customer_location: '남이면 양촌4길',
            price: '120,000',
            status: '상태',
            estimation_charger: '홍길동',
            estimation_date: '2019-11-06'
        }
        ]
    }
  },
  methods: {
  }
}
</script>
